export default "__VITE_ASSET__DZjUhybs__"